import HomeComponent from '../../Components/HomeComponent/HomeComponent';

export default function HomePages() {
  return (
    <>
        <HomeComponent/>
    </>
  )
}
